const publicPath = process.env.PUBLIC_PATH;
const batteryData = require('../../public/notificationAssets/battery/index.json');

export const data = [
  {
    id: 1,
    title: '小鹏汽车维修信息购买流程',
    content: `尊敬的用户，您好！<br/><br/>
    您可免费查看用户手册，如需查看维修手册、电路图等信息，请通过小鹏汽车APP扫下方二维码购买。如果您在使用过程中遇到问题，可以发送邮件至 <a href="mailto:sip@x-peng.cn">sip@x-peng.cn</a>，感谢支持！<br/><br/>
    <div style="width: 100%;display: flex;align-items: center;justify-content: center;"><img src="${publicPath}/notificationAssets/qrcode.png"/></div>
    <br/><br/>使用流程：<br/>
1.登录注册小鹏汽车维修资料平台：<a href="https://sip.xiaopeng.com" target="_blank">https://sip.xiaopeng.com</a>。<br/>
2.发送兑换码和注册账户ID、手机号，以及付款凭证截图附件到管理员邮箱：<a href="mailto:sip@x-peng.cn">sip@x-peng.cn</a><br/>
3.管理员依据验证码和订单信息开通账户查阅权限，并邮件反馈开通成功后即可正常查看。`,
    time: '2025-5-20',
    assets: []
  },
  {
    id: 2,
    title: '动力电池相关信息公示',
    content: '',
    time: '2025-7-10',
    assets: batteryData.map(item => ({
      ...item,
      url: `${publicPath}/notificationAssets/battery/pack/${item.url}`
    }))
  }
];

export const globalData = [
  {
    id: 1,
    title: 'Technical Information Reading Authority Purchase Notification',
    content: `<p>For guest accounts, you can just access to the user manual. If you want to look up other manual such as repair manual, circuit diagram, you have to purchase related authority first. This the introduction of standard procedure.</p>

<strong>Step1</strong>
<h3>Commodity Price</h3>
<p>The permission for viewing documents in the system is priced at "€ 120/d". After purchasing, you can browse all the documents on the website within the validity period.</p>

<strong>Step2</strong>
<h3>Payment Method</h3>
<p>You can transfer money offline to the following account, transfer specific amount corresponding to the validity period you need to purchase. It is particularly important that you must note your email registered on the system website , and then send your purchasing information (including your email registered on the Service information website,too) to this email address:<a href="mailto:overseasserviceengineering@x-peng.cn">overseasserviceengineering@x-peng.cn</a>. Otherwise, we will not be able to identify your transaction and the purchase will be failed.</p>

<ul>
  <li>Currency: EUR</li>
  <li>Beneficiary/Account Name：XPeng European Holding B.V.</li>
  <li>Beneficiary Bank: BNP Paribas SA, Netherlands Branch</li>
  <li>Beneficiary bank address: Herengracht 595 - 1017 CE Amsterdam (The Netherlands) | PO Box 10042 - 1001 EA Amsterdam (The Netherlands)</li>
  <li>Account No. (IBAN): NL82BNPA0227741676</li>
  <li>SWIFT CODE: BNPANL2A</li>
</ul>

<strong>Step3</strong>
<h3>Permission Activation</h3>
<p>Your transaction should be issued within seven business days. We will activate your permission within 72 hours after receiving the transfer. Then, you will receive a notification email and be able to browse the documents. The validity period of your permission will be calculated starting from the first time you log in to the Service information website after activation.</p>
`,
    time: '2025-5-20',
    assets: []
  }
];
